<template>
  <material-card
    v-bind="$attrs"
    class="v-card--material-stats"
    v-on="$listeners"
  >
    <v-card
      slot="offset"
      :class="`elevation-${elevation}`"
      :color="color"
      class="pa-4"
      dark
    >
      <v-icon
        size="40"
      >
        {{ icon }}
      </v-icon>
    </v-card>
    <div class="text-xs-right">
      <p
        class="category black--text"
        v-text="title"
      />
      <h3
        class="title display-1">
        {{ value }} <small class="black--text text--darken-5">{{ smallValue }}</small>
      </h3>
    </div>

    <template slot="actions">
      <v-icon
        :color="subIconColor"
        size="20"
        class="mr-2"
      >
        {{ subIcon }}
      </v-icon>
      <span
        :class="subTextColor"
        class="caption font-weight-light"
        v-text="subText"
      />
    </template>
  </material-card>
</template>

<script>
import Card from './Card'

export default {
  inheritAttrs: false,

  props: {
    ...Card.props,
    icon: {
      type: String,
      required: true
    },
    subIcon: {
      type: String,
      default: undefined
    },
    subIconColor: {
      type: String,
      default: undefined
    },
    subTextColor: {
      type: String,
      default: undefined
    },
    subText: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    },
    smallValue: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss">
.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  background-color: #f5f5f5 !important;
  border: 1px solid rgba(0, 0, 0, .15) !important;
  border-radius: 4px;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;
  }

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .text-xs-right {
    p.category {
      font-size: 1.3rem !important;
      font-weight: 300 !important;
    }

    h3.title.display-1 {
      font-size: 2.3rem !important;
      font-weight: 400 !important;
    }

    h3 small {
      font-size: 2.3rem !important;
      font-weight: 400 !important;
    }
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}

// These two media queries fix the Customer Acquisition Cost card title overflow issue
@media screen and (min-width: 1264px) and (max-width: 1480px) {
  .v-card--material-stats {
    .text-xs-right {
      padding-left: 90px;
      box-sizing: border-box;

      p.category {
        white-space: normal;
       line-height: 1.2;
      }
    }
  }
}

@media screen and (min-width: 600px) and (max-width: 1100px) {
  .v-card--material-stats {
    .text-xs-right {
      padding-left: 90px;
      box-sizing: border-box;

      p.category {
        white-space: normal;
        line-height: 1.2;
      }
    }
  }
}
</style>
